/** @format */
import qs from 'qs';

import { Market } from '@toucan/client/global/market';

import { hasOneProductInResult } from '../helpers';
import {
    ModelSearchResultsSearchParams,
    Query,
    SelectedFilters,
} from '../types';
import { fetchModelSearchResults, getSKUForResult } from './requests';

function alphabeticallySortFilterQuery(
    selectedFilters: SelectedFilters
): SelectedFilters {
    return Object.fromEntries(
        Object.entries(selectedFilters).sort((a, b) => {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
        })
    );
}

export const getSortedFilterQueryString = (
    selectedFilters: SelectedFilters
) => {
    const sortedFilterQuery = alphabeticallySortFilterQuery(selectedFilters);

    return qs.stringify(sortedFilterQuery, { arrayFormat: 'comma' });
};

function getSortQuery(searchParams: ModelSearchResultsSearchParams) {
    const sort = searchParams.sort;

    if (!Object.keys(sort).length) {
        return {
            ['productPrice']: 'DESC',
        };
    }

    const [facet, direction] = Object.entries(sort)[0];

    if (facet === 'relevance') {
        return {};
    }

    return { [facet]: direction };
}

export async function getModelSearchResults(
    baseQuery: Partial<Query>,
    searchParams: ModelSearchResultsSearchParams,
    start: number,
    rows: number,
    activeMarket: Market
) {
    const { outOfStock, selectedFilters } = searchParams;

    const sort = getSortQuery(searchParams);

    const modelSearchResults = await fetchModelSearchResults(
        baseQuery,
        selectedFilters,
        sort,
        start,
        rows,
        activeMarket,
        outOfStock
    );

    if (searchParams.showAll) {
        return modelSearchResults;
    }

    if (hasOneProductInResult(modelSearchResults.results)) {
        modelSearchResults.results[0].productSku = await getSKUForResult(
            baseQuery,
            activeMarket,
            outOfStock
        );
    }

    return modelSearchResults;
}
